import { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { MessageGroupApi, MessageTypeApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import { base_form_fields, createDropdownField } from '../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { MessageGroup, MessageType, Name } from '../../../../Constant';
import useAuth from '../../../../Hooks/useAuth';

const MessageTypeCreate = () => {
  const [formFields, setFormFields] = useState(base_form_fields(`${MessageType}`))
  const [IsNewFieldAdded, setIsNewFieldAdded] = useState(false)
  const history = useNavigate();
  const axiosPrivate = useAxiosPrivate()
  const { userOrganisationId } = useAuth();
  const { layoutURL } = useContext(CustomizerContext);
  const lists = `${process.env.PUBLIC_URL}/crm/settings/message-type/${layoutURL}`;

  const { formState: { errors }, } = useForm();
  
  const addNewRecord = async (newRecord) => {
    if (newRecord === '') {
      errors.showMessages();
    }

    const newRecordTemp = {
      message_group_id: newRecord.message_group_id,
      name: newRecord.name,
      description: newRecord.description,
      color: newRecord.color,
      is_active: newRecord.is_active,
    };

    try {
      await axiosPrivate.post(MessageTypeApi, newRecordTemp).then((resp) => {
        toast.success(`${resp.data.name} is successfully added.`)
        history(lists);
      });
    } catch (error) {
      if (error.response && error.response.status === 422) {
        toast.error('Validation Errors');
      } else if (error.response && error.response.status === 400) {
        toast.error(error.response.data.detail);
      }
      else {
        toast.error('Form submission error');
      }
      throw error;
    }
  };

 const MessageGroupDropdownField = createDropdownField(axiosPrivate,
    'message_group_id',
    'message_group_id',
    `${MessageGroup}`,
    `${MessageGroupApi}?organisation_id=${userOrganisationId}`,
    '', 12
  );

  useEffect(() => {

    const fetchData = async () => {
      try {
        if (!IsNewFieldAdded) {

          const updatedFields = [MessageGroupDropdownField, ...formFields];
          await updatedFields[0].fetchOptions();

          setFormFields(updatedFields);
          setIsNewFieldAdded(true);
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
    };

    fetchData();
  }, [formFields, IsNewFieldAdded]);

  return (
    <Fragment>
      <Breadcrumbs parent="CRM" title="New Message Type" mainTitle="New Message Type" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default MessageTypeCreate;